import { request } from "../core/request";
import { withBody } from "../utils/withBody";

export function put(
  uri: string,
  body?: Record<string, string | number | boolean | undefined | string[] | number[]> | FormData | Object,
  options?: RequestInit,
) {
  if (!options) {
    options = {};
  }
  options.method = "PUT";
  if (body) {
    withBody(body, options);
  }
  return request(uri, options);
}
